'use client';

import { FC, useContext, useState, useEffect } from 'react';
import { Alert } from '@/_components';
import { onValueFirebase, uiVersionCountRef } from '@/_libs/firebase';
import { FirmSettingsContext } from '@/_contexts/FirmSettingsProvider';

export const MaintenanceBanner: FC = () => {
  const { firm } = useContext(FirmSettingsContext);

  const [maintenanceBannerText, setMaintenanceBannerText] = useState<
    string | null
  >(null);

  useEffect(() => {
    onValueFirebase(uiVersionCountRef, (snapshot) => {
      const data = snapshot.val();

      if (
        data.global_alert &&
        data.global_alert.show &&
        data.global_alert.text
      ) {
        setMaintenanceBannerText(data.global_alert.text);
      }
    });
  }, []);

  if (!maintenanceBannerText) {
    return null;
  }

  // Hide for Enoch's demo firm
  if (firm?.id === 482) {
    return null;
  }

  return (
    <div>
      <Alert type="info" icon="clock" isLimitedPadding={true}>
        {maintenanceBannerText}
      </Alert>
    </div>
  );
};
